import { PenLine } from 'lucide-react';

import { cn } from '@/lib/cn';

interface Props {
  onClick: () => void;
  /** Extra offset above `--chrome-bottom` (tab + focus bars). */
  className?: string;
}

/**
 * Capture FAB: braindump entry, ≤2 taps from anywhere on mobile.
 * Sits above the stacked bottom chrome (tabs + optional focus bar).
 */
export function CaptureFab({ onClick, className }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Capture"
      className={cn(
        'pressable fixed z-chrome sm:hidden',
        'right-4 inline-flex size-14 items-center justify-center rounded-full',
        'bg-accent text-text-on-accent shadow-lifted hover:bg-accent-hover',
        'bottom-[calc(var(--chrome-bottom,0px)+0.75rem)]',
        className,
      )}
    >
      <PenLine size={22} strokeWidth={1.5} aria-hidden />
    </button>
  );
}
